import { configureStore } from "@reduxjs/toolkit";

import mappingReducer from "../store/slice/mappingSlice";
import subscriptionReducer from "../store/slice/subscriptionSlice"
import modalReducer from "../store/slice/modalSlice"
import SearchWindowReducer from "../store/slice/searchWindowSlice"

export const store = configureStore({
  reducer: {
    mapping: mappingReducer,
    subscription: subscriptionReducer,
    modal: modalReducer,
    searchWindow: SearchWindowReducer,
  },
});
